import React, { useRef, useState, useEffect } from 'react'
import axios from '../../AxiosConfig'
import EditShareBanner from '../Elements/Modals/EditShareBanner'
import { connect } from 'react-redux'
import { showEditShareBanner } from '../../features/modal/offcanvasSlice'
import { fetchImagesToShare, getContrastColor } from '../../features/share/shareSlice'
import { Stage, Layer, Image, Rect, Text } from 'react-konva'
import useImage from 'use-image'
import Brand from '../images/webweb.svg'
import jwt_decode from 'jwt-decode'

const CERULEAN = '#000000'
const DEEP_CERULEAN = '#006CB5'

const callSVG =
  '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="0.0733346in" height="0.0733307in" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 1.92 1.92" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"><defs><style type="text/css"><![CDATA[.fil1 {fill:#FEFEFE}.fil0 {fill:#FFFFFF}]]></style></defs><g id="Layer_x0020_1"><metadata id="CorelCorpID_0Corel-Layer"/><g id="_1152909584"><circle className="fil0" cx="0.96" cy="0.96" r="0.96"/><path className="fil1" d="M0.27 1.05c-0.05,-0.41 0.25,-0.74 0.61,-0.78 0.41,-0.05 0.74,0.26 0.78,0.61 0.05,0.41 -0.26,0.74 -0.61,0.78 -0.41,0.05 -0.74,-0.26 -0.78,-0.61zm0.8 0.13c-0.14,-0.03 -0.29,-0.18 -0.32,-0.32 0.03,-0.03 0.07,-0.06 0.07,-0.13 -0,-0.03 -0.03,-0.14 -0.05,-0.16 -0.07,-0.12 -0.39,-0.06 -0.2,0.38 0.02,0.05 0.04,0.09 0.07,0.13 0.01,0.02 0.03,0.04 0.04,0.06 0.02,0.03 0.03,0.03 0.05,0.05 0.05,0.05 0.02,0.04 0.1,0.09 0.11,0.08 0.37,0.17 0.47,0.12 0.01,-0.01 0.09,-0.08 0.1,-0.1 0.06,-0.13 -0.11,-0.18 -0.2,-0.19 -0.08,-0.01 -0.1,0.04 -0.14,0.07zm-0.21 -1.01c-0.4,0.06 -0.75,0.42 -0.68,0.91 0.06,0.4 0.43,0.75 0.91,0.68 0.4,-0.06 0.75,-0.43 0.68,-0.91 -0.06,-0.41 -0.44,-0.75 -0.9,-0.68z"/></g></g></svg>'

const emailSVG =
  '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="0.0733346in" height="0.0733307in" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 2.23 2.23" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"><defs><style type="text/css"><![CDATA[.fil0 {fill:#FEFEFE}.fil1 {fill:#FFFFFF}]]></style></defs><g id="Layer_x0020_1"><metadata id="CorelCorpID_0Corel-Layer"/><g id="_1116326912"><path className="fil0" d="M0.47 1.21c0.31,0.41 0.58,0.39 0.68,-0.04l-0.04 0c0.07,0.09 0.18,0.17 0.28,0.19 0.05,-0.03 0.07,-0.09 0.16,-0.08 0.1,0.01 0.3,0.07 0.23,0.22 -0.01,0.02 -0.1,0.11 -0.11,0.12 -0.12,0.06 -0.41,-0.05 -0.54,-0.14 -0.14,-0.09 -0.24,-0.23 -0.31,-0.38 -0.22,-0.52 0.15,-0.58 0.23,-0.44 0.01,0.02 0.05,0.16 0.05,0.19 0.01,0.08 -0.04,0.11 -0.08,0.15 0,0.03 0.02,0.06 0.03,0.09 0.02,-0.06 0.08,-0.14 0.14,-0.22 0.01,-0.16 0,-0.35 -0.02,-0.57 0.48,-0.06 0.86,0.3 0.91,0.71 0.06,0.48 -0.3,0.86 -0.71,0.91 -0.47,0.06 -0.86,-0.3 -0.9,-0.71zm0.68 -1.02c-0.47,0.07 -0.87,0.49 -0.79,1.05 0.07,0.47 0.5,0.87 1.05,0.79 0.47,-0.07 0.87,-0.5 0.79,-1.05 -0.07,-0.47 -0.51,-0.87 -1.05,-0.79z"/><circle className="fil1" cx="1.12" cy="1.12" r="1.12"/><path className="fil0" d="M0.99 0.2c-0.47,0.07 -0.87,0.49 -0.79,1.05 0.07,0.47 0.5,0.87 1.05,0.79 0.47,-0.07 0.87,-0.5 0.79,-1.05 -0.07,-0.47 -0.51,-0.87 -1.05,-0.79zm-0.68 1.02c-0.05,-0.48 0.29,-0.85 0.71,-0.91 0.48,-0.06 0.86,0.3 0.91,0.71 0.06,0.48 -0.3,0.86 -0.71,0.91 -0.47,0.06 -0.86,-0.3 -0.9,-0.71z"/><g><path className="fil0" d="M0.93 1.12c0,0 0,0 0.01,0.01 0,0 0,0 0.01,0l0.13 0.11c0.03,0.03 0.03,0.03 0.06,0.01 0.01,-0.01 0.01,-0.01 0.02,-0.02l0.12 -0.1c0,-0 0.01,-0.01 0.01,-0.01l0.36 0.36c-0.01,0 -0.01,0 -0.03,0l-1.04 0c-0.01,0 -0.02,-0 -0.03,-0l0.36 -0.36zm0.4 -0.03l0.04 -0.04c0.01,-0.01 0.01,-0.01 0.02,-0.02l0.2 -0.17c0.02,-0.01 0.03,-0.02 0.04,-0.04 0.01,-0.01 0.01,-0.01 0.02,-0.02 0,-0 0.01,-0.01 0.01,-0.01 0,-0 0.01,-0.01 0.01,-0.01 0.01,0.02 0,0.13 0,0.16l0 0.41c0,0.03 0,0.06 -0,0.08 -0.01,-0 -0.02,-0.02 -0.02,-0.02l-0.16 -0.16c-0.05,-0.05 -0.11,-0.11 -0.16,-0.16 -0,-0 -0.01,-0.01 -0.01,-0.01 -0,-0 -0.01,-0.01 -0.01,-0.01zm-0.8 0.36l-0 -0.63c0,-0.01 0,-0.02 0,-0.03l0.27 0.22c0.01,0.01 0.01,0.01 0.02,0.02 0.01,0.01 0.06,0.05 0.07,0.06 -0,0 -0.01,0.01 -0.01,0.01 -0,0 -0.01,0.01 -0.01,0.01l-0.07 0.07c-0.03,0.03 -0.06,0.06 -0.09,0.09 -0.03,0.03 -0.06,0.06 -0.09,0.09l-0.07 0.07c-0.01,0.01 -0.02,0.02 -0.02,0.02zm0.6 -0.25c-0.01,0 -0.01,0.01 -0.02,0.01 -0,-0 -0.07,-0.06 -0.08,-0.07l-0.24 -0.2c-0.03,-0.02 -0.09,-0.07 -0.12,-0.1l-0.1 -0.08c0.02,-0.01 0.11,-0 0.13,-0l0.82 0c0.02,0 0.12,-0 0.13,0l-0.19 0.16c-0.03,0.02 -0.07,0.06 -0.1,0.08 -0.04,0.03 -0.09,0.07 -0.12,0.1l-0.12 0.1zm0.61 0.24c0,-0.02 0,-0.04 0,-0.06l0 -0.46c0,-0.03 0,-0.1 -0,-0.13 -0.01,-0.03 -0.03,-0.06 -0.06,-0.07 -0.03,-0.02 -0.08,-0.01 -0.12,-0.01 -0.31,0 -0.61,0 -0.92,0 -0.04,0 -0.08,-0.01 -0.11,0.02 -0.01,0 -0.01,0.01 -0.02,0.01 -0.04,0.04 -0.03,0.07 -0.03,0.13l0 0.46c0,0.03 -0,0.1 0,0.13 0.01,0.03 0.03,0.06 0.06,0.07 0.03,0.02 0.08,0.01 0.12,0.01l0.92 0c0.04,0 0.08,0.01 0.11,-0.02 0.02,-0.02 0.05,-0.04 0.05,-0.08z"/></g></g></g></svg>'

const canvasSize = 1200
const canvasPadding = (canvasSize * 5) / 100
const logoSize = (canvasSize * 13) / 100
const footerHeight = (canvasSize * 10) / 100
const svgPadding = (canvasSize * 8) / 100
const textFontSize = (canvasSize * 4) / 100
const iconFontSize = (canvasSize * 3) / 100
const iconSize = (canvasSize * 4) / 100

const pulseShape = (shape) => {
  shape.to({
    scaleX: 1.3,
    scaleY: 1.3,
    onFinish: () => {
      shape.to({
        scaleX: 1,
        scaleY: 1,
      });
    },
  });
};

const ImageToShare = ({
  brand,
  canvasText,
  callIcon,
  canvasNumber,
  canvasEmail,
  emailIcon,
  fontFamily,
  footerProperties,
  image,
  logoPosition,
  stageRef,
  draggingItems
}) => {
  // console.log(draggingItems);
  const [draggingItemsTemp, setDraggingItemsTemp] = useState('')
  
  useEffect(() => {
    if(draggingItemsTemp !== draggingItems) {
      if(draggingItems === 'phoneAdjust') {
        pulseShape(PhoneAdjust.current)
      } else if(draggingItems === 'emailAdjust') {
        pulseShape(EmailAdjust.current)
      } else if(draggingItems === 'websiteAdjust') {
        pulseShape(WebsiteAdjust.current)
      } else if(draggingItems === 'qrcodeAdjust') {
        pulseShape(QRCodeAdjust.current)
      } else {
        pulseShape(LogoAdjust.current)
      }
    }
    setDraggingItemsTemp(draggingItems ? draggingItems : 'logoAdjust');
  }, [draggingItems])
  
  const PhoneAdjust = useRef(null);
  const EmailAdjust = useRef(null);
  const WebsiteAdjust = useRef(null);
  const QRCodeAdjust = useRef(null);
  const LogoAdjust = useRef(null);


  const [PositionAdjust, setPositionAdjust] = useState({
    phone: {
      x: canvasPadding / 2,
      y: canvasSize - footerHeight + canvasPadding / 2 + 1,
    },
    email: {
      x: canvasPadding / 2 + canvasSize / 2,
      y: canvasSize - footerHeight + canvasPadding / 2 + 1
    },
    website: {
      x: 0,
      y: canvasSize - footerHeight - (canvasSize * 11) / 100
    },
    qrcode: {
      x: 0,
      y: 0
    },
    logo: {
      x: logoPosition === '0' ? canvasSize - logoSize - canvasPadding : canvasPadding,
      y: canvasPadding
    }
  })

  const getPositionAdjustTemp = () => {
    const positionAdjustTemp = JSON.parse(JSON.stringify(PositionAdjust));
    return positionAdjustTemp;
  }

  const functionToPositionChangedX = (e) => {
    const getCurrentPositionTemp = getPositionAdjustTemp();
    const ValueX = Number(e.target.value);

    if(draggingItemsTemp === 'phoneAdjust') {
      // if(ValueX > (canvasPadding/2) && ValueX < canvasSize - (canvasPadding/2) - (iconSize + )) {
        getCurrentPositionTemp['phone'].x = ValueX;
      // }
    } else if (draggingItemsTemp === 'emailAdjust') {
      getCurrentPositionTemp['email'].x = ValueX;
    } else if (draggingItemsTemp === 'websiteAdjust') {
      getCurrentPositionTemp['website'].x = ValueX;
    } else if (draggingItemsTemp === 'qrcodeAdjust') {
      getCurrentPositionTemp['qrcode'].x = ValueX;
    } else {
      if(ValueX > (canvasPadding/2) && ValueX < canvasSize - (canvasPadding/2) - logoSize) {
        getCurrentPositionTemp['logo'].x = ValueX;
      }
    }
    setPositionAdjust(getCurrentPositionTemp);
  }

  const functionToPositionChangedY = (e) => {
    const getCurrentPositionTemp = getPositionAdjustTemp();
    const ValueY = Number(e.target.value);

    if(draggingItemsTemp === 'phoneAdjust') {
      if(ValueY > (canvasPadding/2) && ValueY < canvasSize - (canvasPadding/2) - iconSize) {
        getCurrentPositionTemp['phone'].y = ValueY;
      }
    } else if (draggingItemsTemp === 'emailAdjust') {
      if(ValueY > (canvasPadding/2) && ValueY < canvasSize - (canvasPadding/2) - iconSize) {
        getCurrentPositionTemp['email'].y = ValueY;
      }
    } else if (draggingItemsTemp === 'websiteAdjust') {
      if(ValueY > (canvasPadding/2) && ValueY < canvasSize - (canvasPadding/2) - iconSize) {
        getCurrentPositionTemp['website'].y = ValueY;
      }
    } else if (draggingItemsTemp === 'qrcodeAdjust') {
      getCurrentPositionTemp['qrcode'].y = ValueY;
    } else {
      if(ValueY > (canvasPadding/2) && ValueY < canvasSize - (canvasPadding/2) - logoSize) {
        getCurrentPositionTemp['logo'].y = ValueY;
      }
    }

    setPositionAdjust(getCurrentPositionTemp);
  }

  const getPositionForXInputs = (x) => {
    let phoneXposition;
    if(x === 'phoneAdjust') {
      phoneXposition = PositionAdjust['phone']['x'];
    } else if(x === 'emailAdjust') {
      phoneXposition = PositionAdjust['email']['x'];
    } else if(x === 'websiteAdjust') {
      phoneXposition = PositionAdjust['website']['x'];
    } else if(x === 'qrcodeAdjust') {
      phoneXposition = PositionAdjust['qrcode']['x'];
    } else {
      phoneXposition = PositionAdjust['logo']['x'];
    }
    return phoneXposition;
  }

  const getPositionForYInputs = (y) => {
    let phoneYposition;
    if(y === 'phoneAdjust') {
      phoneYposition = PositionAdjust['phone']['y'];
    } else if(y === 'emailAdjust') {
      phoneYposition = PositionAdjust['email']['y'];
    } else if(y === 'websiteAdjust') {
      phoneYposition = PositionAdjust['website']['y'];
    } else if(y === 'qrcodeAdjust') {
      phoneYposition = PositionAdjust['qrcode']['y'];
    } else {
      phoneYposition = PositionAdjust['logo']['y'];
    }
    return phoneYposition;
  }

  // console.log(PositionAdjust.y - 30, footerProperties.textColor1);

  const callToCheck = (e) => {
    console.log(e)
  }

  return (
    <div className="mb-1 text-center konva-parent-custom d-flex justify-content-center flex-column align-items-center inputes-ranges">

      <input type="range" id="topBottom" name="topBottom" value={draggingItemsTemp && getPositionForXInputs(draggingItemsTemp)} min="0" className='horizontalRange' max={canvasSize} onChange={(e) => functionToPositionChangedX(e)}/>

      <div className='position-relative'>
        
        <input type="range" id="leftRight" name="topBottom" value={draggingItemsTemp && getPositionForYInputs(draggingItemsTemp)} min="0" className='verticalRange' max={canvasSize} onChange={(e) => functionToPositionChangedY(e)}/>

        <Stage width={canvasSize} height={canvasSize} ref={stageRef}>
          <Layer width={canvasSize} heigt={canvasSize}>
            <Rect
              fill={footerProperties.color1}
              width={canvasSize}
              height={canvasSize}
            />
          </Layer>
          {/* <Layer>
            <Image
              image={image}
              width={canvasSize - svgPadding}
              height={canvasSize - svgPadding}
              x={0}
              y={0}
            />
          </Layer> */}
          <Layer>
            <Image
              image={image}
              width={canvasSize}
              height={canvasSize}
              x={0}
              y={0}
            />
          </Layer>
          <Layer>
            <Image
              image={brand}
              width={logoSize}
              height={logoSize}
              x={PositionAdjust.logo.x}
              y={PositionAdjust.logo.y}
              ref={LogoAdjust}
              cornerRadius={50}
            />
          </Layer>
          <Layer>
            <Text
              text={canvasText}
              align="center"
              fontFamily={fontFamily}
              width={canvasSize}
              fontSize={textFontSize}
              x={PositionAdjust.website.x}
              // stroke={draggingItemsTemp === 'websiteAdjust' && 'red'}
              // strokeWidth={draggingItemsTemp === 'websiteAdjust' && 2}
              y={PositionAdjust.website.y}
              lineHeight={1.1}
              fill={getContrastColor(footerProperties.color1)}
              ref={WebsiteAdjust}
            />
          </Layer>
          {/* <Layer>
            <Rect
              width={canvasSize}
              height={1200}
              fill={footerProperties.color1}
              x={0}
              y={canvasSize - footerHeight}
            />
          </Layer> */}
          {footerProperties.contact && footerProperties.email && (
            <>
              <Layer>
                  <Image
                    image={callIcon}
                    width={iconSize}
                    height={iconSize}
                    draggable
                    x={PositionAdjust.phone.x}
                    y={PositionAdjust.phone.y}
                    id="callTextIcon"
                    onClick={callToCheck}
                    // stroke={draggingItemsTemp === 'phoneAdjust' && 'red'}
                    // strokeWidth={draggingItemsTemp === 'phoneAdjust' && 2}
                    onMouseDown={() => callToCheck('Call')}
                    ref={PhoneAdjust}
                  />
                  <Text
                    text={canvasNumber}
                    fontFamily={fontFamily}
                    height={footerHeight}
                    fontSize={iconFontSize}
                    x={PositionAdjust.phone.x + iconSize + 20}
                    y={PositionAdjust.phone.y - 30}
                    verticalAlign="middle"
                    fill={getContrastColor(footerProperties.color1)}
                    id="callText"
                    // stroke={draggingItemsTemp === 'phoneAdjust' && 'red'}
                    // strokeWidth={draggingItemsTemp === 'phoneAdjust' && 2}
                    onMouseDown={() => callToCheck('Call')}
                  />
              </Layer>
              <Layer>
                <Image
                  image={emailIcon}
                  width={iconSize}
                  height={iconSize}
                  x={PositionAdjust.email.x}
                  y={PositionAdjust.email.y}
                  // stroke={draggingItemsTemp === 'emailAdjust' && 'red'}
                  //   strokeWidth={draggingItemsTemp === 'emailAdjust' && 2}
                  ref={EmailAdjust}
                />
                <Text
                  text={canvasEmail}
                  fontFamily={fontFamily}
                  height={footerHeight}
                  fontSize={iconFontSize}
                  x={PositionAdjust.email.x + iconSize + 20}
                  y={PositionAdjust.email.y - 30}
                  verticalAlign="middle"
                  // stroke={draggingItemsTemp === 'emailAdjust' && 'red'}
                  //   strokeWidth={draggingItemsTemp === 'emailAdjust' && 2}
                  fill={getContrastColor(footerProperties.color1)}
                />
              </Layer>
            </>
          )}
          {footerProperties.contact && !footerProperties.email && (
            <Layer>
              {/* <Image image={callIcon} width={iconSize} height={iconSize} x={svgPadding / 2} y={(canvasSize - footerHeight) + (canvasPadding / 2) + 1} /> */}
              <Text
                text={canvasNumber}
                fontFamily={fontFamily}
                height={footerHeight}
                fontSize={iconFontSize}
                x={0}
                width={canvasSize}
                align="center"
                y={canvasSize - footerHeight + 1}
                verticalAlign="middle"
                // stroke={draggingItemsTemp === 'phoneAdjust' && 'red'}
                // strokeWidth={draggingItemsTemp === 'phoneAdjust' && 2}
                ref={PhoneAdjust}
                fill={footerProperties.textColor1}
                draggable={true}
              />
            </Layer>
          )}
          {footerProperties.email && !footerProperties.contact && (
            <Layer>
              {/* <Image image={emailIcon} width={iconSize} height={iconSize} x={(canvasPadding / 2) + (canvasSize / 2)} y={(canvasSize - footerHeight) + (canvasPadding / 2) + 1} /> */}
              <Text
                text={canvasEmail}
                fontFamily={fontFamily}
                height={footerHeight}
                fontSize={iconFontSize}
                x={0}
                width={canvasSize}
                y={canvasSize - footerHeight + 1}
                align="center"
                verticalAlign="middle"
                // stroke={draggingItemsTemp === 'phoneAdjust' && 'red'}
                // strokeWidth={draggingItemsTemp === 'phoneAdjust' && 2}
                ref={EmailAdjust}
                fill={footerProperties.textColor1}
              />
            </Layer>
          )}
        </Stage>
      </div>
    </div>
  )
}

const Share = ({
  showEditShareBanner,
  isEditBannerVisible,
  bannerData,
  websiteDataAppearnace,
  fetchImagesToShare,
  imagesToShare,
  websiteDataBlocks,
  loadingImages,
  draggingItems,
  CompleteJSON
}) => {
  const [svgImage, setSvg] = useState('')
  const [currentImage, setCurrentImage] = useState(null)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const [footerProperties, setFooterProperties] = useState('')
  const [logoPosition, setLogoPosition] = useState('')
  const [bannerTitle, setBannerTitle] = useState('Banner Image')
  const [themeFontFamily, setThemeFontFamily] = useState('')

  const fetchWebsiteJSON = () => {
    const webDoc = CompleteJSON; //localStorage.getItem('website')
    const res = webDoc // ? JSON.parse(atob(webDoc)) : false
    if (res) {
      return res
    } else {
      return false
    }
  }

  useEffect(() => {
    fetchImagesToShare()
  }, [])

  useEffect(() => {
    // console.log("imagesToShare", imagesToShare);
    if (imagesToShare && imagesToShare.length > 0) {
      const currentImageTmp = imagesToShare[currentImageIndex]
      const { FooterProperties, Image, LogoLeft, Title } = currentImageTmp
      setCurrentImage(currentImageTmp)
      setFooterProperties(JSON.parse(FooterProperties))
      setSvg(Image)
      setLogoPosition(LogoLeft)
      setBannerTitle(Title) 
    }
  }, [imagesToShare, currentImageIndex, setCurrentImage])

  useEffect(() => {
    if (currentImage) {
      setSvg(currentImage.Image.replace(/#00AFEF/gi, footerProperties.color1))
    }
  }, [setSvg, footerProperties, currentImage])

  useEffect(() => {
    if (websiteDataAppearnace.hasOwnProperty('propperties')) {
      setThemeFontFamily(websiteDataAppearnace.properties.font.fontFamily)
    } else {
      const websiteJSON = fetchWebsiteJSON()
      setThemeFontFamily(websiteJSON.appearance.properties.font.fontFamily)
    }
  }, [websiteDataAppearnace])

  const token = localStorage.getItem('token')
  const tokenData = token ? jwt_decode(token) : false
  const selectedDomain = tokenData.SelectedDomain.AliasDomain !== '' ? tokenData.SelectedDomain.AliasDomain :  tokenData.SelectedDomain.Domain
  // console.log(tokenData.SelectedDomain);
  const callSVGTmp = callSVG.replace(/#FEFEFE/g, footerProperties.textColor1)
  // console.log(callSVGTmp);
  const emailSVGTmp = emailSVG.replace(/#FEFEFE/g, footerProperties.textColor1)
  // console.log(emailSVGTmp);
  function downloadURI(uri, name) {
    var link = document.createElement('a')
    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const [disableDonwload, setDisableDonwload] = useState(false)
  const [imageColor, setImageColor] = useState('')
  const [dynamicLogo, setDynamicLogo] = useState('')
  const [image] = useImage(
    svgImage !== '' && !svgImage.includes('<?xml')
      ? svgImage
      : 'data:image/svg+xml;base64,' + window.btoa(svgImage)
  )
  const handleShareEdit = () => {
    showEditShareBanner({
      bannerData: currentImage
      // bannerID: imagesToShare[currentImageIndex]['ID']
    })
  }

  // console.log(image);

  useEffect(() => {
    // console.log(imagesToShare[0])
    if(loadingImages === 'loaded') {
        showEditShareBanner({
          bannerData: imagesToShare[0],
          bannerID: 0,
          draggingItems: draggingItems ? draggingItems : 'logoAdjust'
        })
    }
  }, [loadingImages])

  useEffect(() => {
    Object.keys(websiteDataBlocks).map((key, value) => {
      if (key.includes('SM_HEAD')) {
        setDynamicLogo(websiteDataBlocks[key]['items'][0]['image'][0]['src'])
      }
    })
  }, [websiteDataBlocks])

  const [callIcon] = useImage(
    'data:image/svg+xml;base64,' + window.btoa(callSVGTmp)
  )
  
  const [emailIcon] = useImage(
    'data:image/svg+xml;base64,' + window.btoa(emailSVGTmp)
  )
  const [brand] = useImage(
    dynamicLogo !== ''
      ? dynamicLogo
      : 'https://webweb.ams3.cdn.digitaloceanspaces.com/webweb.svg'
  )
  const [canvasTitle, setCanvasTitle] = useState(bannerTitle)
  const [canvasText, setCanvasText] = useState(selectedDomain)
  const [canvasNumber, setCanvasNumber] = useState('+91 9221351786')
  const [canvasEmail, setCanvasEmail] = useState(tokenData.userInfo.Email ? tokenData.userInfo.Email : 'example@example.com')
  const fontFamily = themeFontFamily

  // console.log(tokenData);
  useEffect(() => {
    setImageColor('#f21b2d')
  }, [imageColor])

  const stageRef = useRef(null)

  const handleExport = () => {
    const uri = stageRef.current.toDataURL()
    downloadURI(uri, canvasTitle)
    setDisableDonwload(true)
    setTimeout(function () {
      setDisableDonwload(false)
    }, 5000)
  }

  const nextImageBanner = () => {
    if (imagesToShare.length - 1 === currentImageIndex) {
      setCurrentImageIndex(0)
      showEditShareBanner({
        bannerData: imagesToShare[0],
        bannerID: 0,
        draggingItems: draggingItems ? draggingItems : 'logoAdjust'
      })
    } else {
      setCurrentImageIndex(currentImageIndex + 1)
      showEditShareBanner({
        bannerData: imagesToShare[currentImageIndex + 1],
        bannerID: currentImageIndex + 1,
        draggingItems: draggingItems ? draggingItems : 'logoAdjust'
      })
    }
  }

  const prevImageBanner = () => {
    if (currentImageIndex === 0) {
      setCurrentImageIndex(imagesToShare.length - 1)
      showEditShareBanner({
        bannerData: imagesToShare[imagesToShare.length - 1],
        bannerID: imagesToShare.length - 1,
        draggingItems: draggingItems ? draggingItems : 'logoAdjust'
      })
    } else {
      setCurrentImageIndex(currentImageIndex - 1)
      showEditShareBanner({
        bannerData: imagesToShare[currentImageIndex - 1],
        bannerID: currentImageIndex - 1,
        draggingItems: draggingItems ? draggingItems : 'logoAdjust'
      })
    }
  } 

  return (
    <div class="">
      <div class="row">
        <div class="col-md-7 position-relative">
          <div className="section full">
            {image ? (
              <>
                <ImageToShare
                  brand={brand}
                  canvasText={canvasText}
                  callIcon={callIcon}
                  canvasNumber={canvasNumber}
                  canvasEmail={canvasEmail}
                  emailIcon={emailIcon}
                  fontFamily={fontFamily}
                  footerProperties={footerProperties}
                  image={image}
                  logoPosition={logoPosition}
                  stageRef={stageRef}
                  draggingItems={draggingItems}
                />
                <div class="d-flex justify-content-center">
                  <span class="badge badge-sm bg-secondary fs-10" onClick={handleExport}><ion-icon name="download-outline" class="text-light"></ion-icon>&nbsp;DOWNLOAD</span>
                </div>
              </>
            ) : (
              <>
                <div className='image-loading-card'>
                  <div className="spinner-border text-primary" role="status" />
                </div>
              </>
            )}
          </div>
          <div
            className="position-absolute bg-transparent border-0 d-flex flex-row w-100 justify-content-between prevNextBtnsSocial">
            <div
              className="text-center me-1 d-flex flex-column"
            >
              <button
                type="button"
                className="btn btn-icon text-secondary rounded"
                onClick={prevImageBanner}
                style={{ pointerEvents: 'painted' }}
              >
                <ion-icon name="arrow-back-outline"></ion-icon>
              </button>
              <span style={{ fontSize: '12px' }}>Prev</span>
            </div>
            {/* <div className="text-center me-2 d-flex flex-column">
              <button
                type="button"
                className="btn btn-icon btn-outline-secondary rounded"
                onClick={() => {
                  handleShareEdit()
                }}
              >
                <ion-icon name="create-outline"></ion-icon>
              </button>
              <span style={{ fontSize: '12px' }}>Edit</span>
            </div>
            <div
              className="text-center me-2 d-flex flex-column"
              style={{ cursor: 'not-allowed' }}
            >
              <button
                type="button"
                className="btn btn-icon btn-outline-secondary rounded"
                disabled
              >
                <ion-icon name="share-social-outline"></ion-icon>
              </button>
              <span style={{ fontSize: '12px' }} className="text-secondary">
                Share
              </span>
            </div>
            <div className="text-center me-2 d-flex flex-column">
              <button
                type="button"
                className="btn btn-icon btn-outline-secondary rounded"
                onClick={handleExport}
                disabled={disableDonwload}
              >
                <ion-icon name="download-outline"></ion-icon>
              </button>
              <span style={{ fontSize: '12px' }}>Download</span>
            </div> */}
            <div
              className="text-center me-2 d-flex flex-column-reverse"
            >
              <span style={{ fontSize: '12px' }}>Next</span>
              <button
                type="button"
                className="btn btn-icon text-secondary rounded"
                onClick={nextImageBanner}
                style={{ pointerEvents: 'painted' }}
              >
                <ion-icon name="arrow-forward-outline"></ion-icon>
              </button>
              
            </div>
          </div>
            {currentImage && (
              <div class="card m-2">
                <div class="card-body p-0">
                  <EditShareBanner
                    bannerData={currentImage}
                    bannerID={imagesToShare[currentImageIndex]['ID']}
                    components={['colors']}
                  />
                </div>
              </div>
            )}
        </div>
        <div class="col-md-5">
          {currentImage && (
              <div class="card m-2">
                <div class="card-body p-0">
                  <EditShareBanner
                    bannerData={currentImage}
                    bannerID={imagesToShare[currentImageIndex]['ID']}
                    components={['showHide', 'adjust']}
                    canvasText={canvasText}
                    setCanvasText={setCanvasText}
                    canvasNumber={canvasNumber}
                    setCanvasNumber={setCanvasNumber}
                    canvasEmail={canvasEmail}
                    setCanvasEmail={setCanvasEmail}
                  />
                </div>
              </div>
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ offcanvas, websiteData, share }) => {
  const { isEditBannerVisible, bannerData, draggingItems } = offcanvas
  const { appearance: websiteDataAppearnace, blocks: websiteDataBlocks, CompleteJSON } =
    websiteData
  const { imagesToShare, loadingImages } = share
  return {
    isEditBannerVisible,
    bannerData,
    websiteDataAppearnace,
    imagesToShare,
    websiteDataBlocks, 
    loadingImages, 
    CompleteJSON,
    draggingItems
  }
}

const mapDispatchToProps = {
  showEditShareBanner,
  fetchImagesToShare
}

export default connect(mapStateToProps, mapDispatchToProps)(Share)
